import { useEffect, useState } from 'react';
import { pendingCount, QUEUE_EVENT } from '@/lib/offline-queue';

/** Tracks the browser's online/offline state. */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

/** How many offline changes are waiting to sync; updates as the queue changes. */
export function usePendingSync(): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    const refresh = () => {
      void pendingCount().then((n) => {
        if (alive) setCount(n);
      });
    };
    refresh();
    window.addEventListener(QUEUE_EVENT, refresh);
    window.addEventListener('online', refresh);
    window.addEventListener('offline', refresh);
    return () => {
      alive = false;
      window.removeEventListener(QUEUE_EVENT, refresh);
      window.removeEventListener('online', refresh);
      window.removeEventListener('offline', refresh);
    };
  }, []);
  return count;
}
